module.exports = __webpack_public_path__ + "media/images/application/favicon/logo-ed0efdbdd364a79ace1afc96bc5e3cc3.png";